import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LocalStorageService } from '@core/services/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class IntervenerRoleGuard implements CanActivate {
  constructor(
    private router: Router,
    private localStorageService: LocalStorageService
  ) {}

  canActivate(): boolean {
    const currentUser = this.localStorageService.getData('UserInfo');
    if (!currentUser) {
      this.router.navigate(['/profil-entreprise/details-profil']);
      return false;
    }

    try {
      const companyRoleId = JSON.parse(currentUser).role_user_id;
      if (companyRoleId.includes('6')) {
        this.router.navigate(['/profil-entreprise/details-profil']);
        return false;
      }
      return true;
    } catch (error) {
      this.router.navigate(['/profil-entreprise/details-profil']);
      return false;
    }
  }
}
